import { Link } from "react-router-dom";
import { ChevronLeft, ChevronRight } from "lucide-react";

export default function DocNavigation({
    previous,
    next
}) {
    return (
        <section className="border-t border-slate-200 pt-12 mt-16">
            <div className="flex justify-between gap-6">

                {/* PREVIOUS */}
                {previous ? (
                    <Link
                        to={previous.link}
                        className="flex items-center justify-between w-full max-w-md bg-white border border-slate-300 rounded-2xl px-3 py-3 hover:bg-slate-100 transition"
                    >
                        <div className="flex items-center gap-3">
                            <ChevronLeft className="w-5 h-5 text-slate-500" />
                            <div>
                                <p className="text-xs uppercase text-slate-400 tracking-wide">
                                    Previous Page
                                </p>
                                <p className="text-sm font-medium text-slate-800">
                                    {previous.title}
                                </p>
                            </div>
                        </div>
                    </Link>
                ) : <div />}

                {/* NEXT */}
                {next ? (
                    <Link
                        to={next.link}
                        className="flex items-center justify-between w-full max-w-md  bg-white border border-slate-300 rounded-2xl px-3 py-3 hover:bg-slate-100 transition ml-auto"
                    >
                        <div className="ml-auto text-right">
                            <p className="text-xs uppercase text-slate-400 tracking-wide">
                                Next Page
                            </p>
                            <p className="text-sm font-medium text-slate-800">
                                {next.title}
                            </p>
                        </div>
                        <ChevronRight className="w-5 h-5 text-slate-500 ml-3" />
                    </Link>
                ) : null}

            </div>
        </section>
    );
}
